import axios from "axios";
import {
  ALL_PRODUCT_REQUEST,
  ALL_PRODUCT_SUCCESS,
  ALL_PRODUCT_FAIL,
  PRODUCT_DETAIL_REQUEST,
  PRODUCT_DETAIL_SUCCESS,
  PRODUCT_DETAIL_FAIL,
  PRODUCT_REVIEW_REQUEST,
  PRODUCT_REVIEW_SUCCESS,
  PRODUCT_REVIEW_FAIL,
  CLEAR_ERRORS,
} from "../constants/productConstants";
import {BASE_URL} from "../helper"
export const getProduct = (keyword="",currentPage=1,price=[0,25000]) => async (dispatch) => {
  try {
    dispatch({ type: ALL_PRODUCT_REQUEST });
    let link=`${BASE_URL}/api/v1/products?keyword=${keyword}&page=${currentPage}&price[gte]=${price[0]}&price[lte]=${price[1]}`;
    const { data } = await axios.get(link);
    console.log(data);
    dispatch({
      type: ALL_PRODUCT_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: ALL_PRODUCT_FAIL,
      payload: error.response.data.message,
    });
  }
};
export const getProductDetails = (id) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_DETAIL_REQUEST });
    const { data } = await axios.get(`${BASE_URL}/api/v1/product/${id}`);
    console.log(data);
    dispatch({
      type: PRODUCT_DETAIL_SUCCESS,
      payload: data.product,
    });
  } catch (error) {
    dispatch({
      type: PRODUCT_DETAIL_FAIL,
      payload: error.response.data.message,
    });
  }
};
export const newReview = (reviewData) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_REVIEW_REQUEST });
    const token = localStorage.getItem('token');
    console.log(`toki ${token}`)
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`
      },
    };
    console.log(`reviewToken ${JSON.stringify(config)}`)
    const { data } = await axios.put(`${BASE_URL}/api/v1/review`,reviewData,config);
    console.log(`data ${data}`);
    dispatch({
      type: PRODUCT_REVIEW_SUCCESS,
      payload: data.success,
    });
  } catch (error) {
    dispatch({
      type: PRODUCT_REVIEW_FAIL,
      payload: error.response.data.message,
    });
  }
};
// clearing errors
export const clearErrors = () => async (dispatch) => {
dispatch({type:CLEAR_ERRORS});
}
